module.exports = __webpack_public_path__ + "static/media/Tiles.df7080c3.jpeg";